import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../helpers/Requests'

import { faLaughBeam, faSmile, faMeh, faFrown, faTired, faStar, faThumbsUp, faThumbsDown } from "@fortawesome/free-regular-svg-icons";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import AlertProcessing from '../components/feedback_questions/AlertProcessing';

import SetTitle from '../components/shared/SetTitle';
import HelpText from '../components/help/HelpText';
import Audits from '../components/shared/Audits';
import NoticeBox from '../components/shared/NoticeBox';

import { adminUser, setIdAndMethod, renderErrors, renderErrorWarning } from '../utilities/Forms.js'

class FeedbackQuestionForm extends Component {
  constructor(props) {
    super(props);

    this.setEmailsValid = this.setEmailsValid.bind(this);
    this.removeInvalidEmails = this.removeInvalidEmails.bind(this);
    this.setAlertErrors = this.setAlertErrors.bind(this);
    this.setNewPanelRedirect = this.setNewPanelRedirect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handleSubmitAlerts = this.handleSubmitAlerts.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  static DEFAULT_OPTIONS = "Type in this box to enter custom options\nEach new line is a new option"

  state = {
    name: "",
    display: "",
    answer_type: this.props.mode === "create" ? null : 0,
    answer_quantity: "5",
    options: FeedbackQuestionForm.DEFAULT_OPTIONS,
    hidden: false,
    analysis_overview: true,

    preview_answer: "4",
    preview_options: [],
    text_answer_preview: "",

    depends_on_question_id: "",
    depends_on_condition: "",
    depends_on_score: null,

    emailsValid: true,
    removeInvalidEmailsCount: 0,
    submitAlertsCount: 0,

    loaded: false,
    unauthorized: "",
    errors: "",
    alertErrors: "",
    error: ""
  };

  setEmailsValid(invalidEmails) {
    this.setState({
      emailsValid: invalidEmails.length === 0
    })
  }

  removeInvalidEmails(event) {
    this.setState(prevState => ({
      removeInvalidEmailsCount: prevState.removeInvalidEmailsCount + 1
    }))

    event.preventDefault();
  }

  setAlertErrors(errors) {
    this.setState({ alertErrors: errors })
  }

  setNewPanelRedirect() {
    this.setState({ redirectNewPanel: true })
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    if (name === "answer_type") {
      if (["smileys", "stars", "thumbs"].includes(value) && this.state.answer_quantity < 4)  {
        this.setState({answer_quantity: "5"})
      }
      else if (value === "boolean" && this.state.answer_quantity > 3) {
        this.setState({answer_quantity: "2"})
      }
    }
  }

  handleCheckbox(event) {
    let name = event.target.name;
    let value = event.target.checked;

    this.setState({[name]: value});
  }

  handleMultiCheckbox(event) {
    const name = event.target.name;
    const value = parseInt(event.target.value);
    const checked = event.target.checked;

    var state = this.state[name]

    if (checked === true) {
      if (!state.includes(value)) {
        state.push(value)
      }
    }
    else if (checked === false) {
      if (state.includes(value)) {
        const index = state.indexOf(value)
        state.splice(index, 1)
      }
    }

    this.setState({[name]: state});
  }

  handleSubmitAlerts(event) {
    this.setState(prevState => ({
      submitAlertsCount: prevState.submitAlertsCount + 1
    }))

    event.preventDefault()
  }

  handleSubmit(event) {
    var json = {
      "feedback_question": {
        "name": this.state.name,
        "display": this.state.display,
        "answer_type": this.state.answer_type,
        "answer_quantity": ["boolean", "smileys", "stars", "thumbs"].includes(this.state.answer_type) ? this.state.answer_quantity : null,
        "options": this.optionsParam(),
        "order": this.state.order,
        "hidden": this.state.hidden,
        "analysis_overview": this.state.analysis_overview,
        "depends_on_question_id": this.state.depends_on_question_id,
        "depends_on_condition": this.state.depends_on_condition === "" ? null : this.state.depends_on_condition,
        "depends_on_score": this.state.depends_on_score
      }
    }

    if (this.props.mode === "create" || this.state.depends_on_question_id.toString() !== this.state.initial_depends_on_question_id.toString()) {
      json["feedback_question"]["feedback_type_id"] = this.props.feedback_type_id
      json["feedback_question"]["order"] = this.calculateOrder()
    }

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    request(method, `/v1/a/feedback_questions/${id}`, JSON.stringify(json), () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState(prevState => ({
          id: data.id,
          updating: false,
          errors: ""
        }))

        this.setState({ errors: "" })
        this.handleSubmitAlerts(event)
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  optionsParam() {
    const options = this.state.options.trim()

    if (options === FeedbackQuestionForm.DEFAULT_OPTIONS) {
      return []
    }

    return options.split("\n").map(option => option.trim()).filter(option => option)
  }

  calculateOrder() {
    const depends_on_question_id = parseInt(this.state.depends_on_question_id) || null
    const length = this.props.feedbackQuestions.filter(feedback_question => feedback_question.depends_on_question_id === depends_on_question_id).length

    return length + 1
  }

  renderQuestionPreview() {
    if (this.state.answer_type === "boolean") {
      return (
        <div className="feedback-preview bottom-margin">
          <div className="small-bottom-margin">Answer Preview:</div>
          <div className="question radio radio-card">
            <input className="column no" type="checkbox" name="preview_answer" value="1" id="no" checked={this.state.preview_answer === "1"} onChange={this.handleChange} />
            <label className="longer" htmlFor="no">No</label>
            { this.state.answer_quantity === "3" &&
              <>
                <input className="column na" type="checkbox" name="preview_answer" value="3" id="n/a" checked={this.state.preview_answer === "3"} onChange={this.handleChange} />
                <label className="longer" htmlFor="n/a">N/A</label>
              </>
            }
            <input className="column yes" type="checkbox" name="preview_answer" value="5" id="yes" checked={this.state.preview_answer === "5"} onChange={this.handleChange} />
            <label className="longer" htmlFor="yes">Yes</label>
          </div>
        </div>
      )
    }

    if (this.state.answer_type === "stars") {
      let numberOfStars = this.state.preview_answer
      var iconType = []

      for (var i = 0; i < numberOfStars; i++) {
        iconType.push("selected")
      }

      return (
        <div className="feedback-preview bottom-margin">
          <div className="small-bottom-margin">Answer Preview:</div>
          <div className="question radio radio-card">

            <div className="mobile-stars">
              <input className="column" type="checkbox" name="preview_answer" value="1" id="one_star" checked={this.state.preview_answer === "1"} onChange={this.handleChange} />
              <label htmlFor="one_star">
                <FontAwesomeIcon icon={iconType[0] ? solidStar : faStar} style={{color: iconType[0] ? "gold" : "#777"}} />
              </label>
              <input className="column" type="checkbox" name="preview_answer" value="2" id="two_stars" checked={this.state.preview_answer === "2"} onChange={this.handleChange} />
              <label htmlFor="two_stars">
                <FontAwesomeIcon icon={iconType[1] ? solidStar : faStar} style={{color: iconType[1] ? "gold" : "#777"}} />
              </label>
              { this.state.answer_quantity === "5" &&
                <>
                  <input className="column" type="checkbox" name="preview_answer" value="3" id="three_stars" checked={this.state.preview_answer === "3"} onChange={this.handleChange} />
                  <label htmlFor="three_stars">
                    <FontAwesomeIcon icon={iconType[2] ? solidStar : faStar} style={{color: iconType[2] ? "gold" : "#777"}} />
                  </label>
                </>
              }
              <input className="column" type="checkbox" name="preview_answer" value="4" id="four_stars" checked={this.state.preview_answer === "4"} onChange={this.handleChange} />
              <label htmlFor="four_stars">
                <FontAwesomeIcon icon={iconType[3] ? solidStar : faStar} style={{color: iconType[3] ? "gold" : "#777"}} />
              </label>
              <input className="column" type="checkbox" name="preview_answer" value="5" id="five_stars" checked={this.state.preview_answer === "5"} onChange={this.handleChange} />
              <label htmlFor="five_stars">
                <FontAwesomeIcon icon={iconType[4] ? solidStar : faStar} style={{color: iconType[4] ? "gold" : "#777"}} />
              </label>
            </div>
          </div>
        </div>
      )
    }

    if (this.state.answer_type === "text") {
      return (
        <div className="feedback-preview bottom-margin">
          <div className="small-bottom-margin">Answer Preview:</div>
          <div className="question text form">
            <textarea aria-required="true" name="text_answer_preview" value={this.state.text_answer_preview} onChange={this.handleChange} />
          </div>
        </div>
      )
    }

    if (this.state.answer_type === "smileys") {
      return (
        <div className="feedback-preview bottom-margin">
          <div className="small-bottom-margin">Answer Preview:</div>
          <div className="question radio radio-card">

            <div className="smileys">
              <span className="very_unhappy">
                <input className="column" type="checkbox" name="preview_answer" value="1" id={`very_unhappy`} checked={this.state.preview_answer === "1"} onChange={this.handleChange} />
                <label htmlFor={`very_unhappy`}>
                  <FontAwesomeIcon icon={faTired} />
                </label>
              </span>
              <span className="unhappy">
                <input className="column" type="checkbox" name="preview_answer" value="2" id={`unhappy`} checked={this.state.preview_answer === "2"} onChange={this.handleChange} />
                <label htmlFor={`unhappy`}>
                  <FontAwesomeIcon icon={faFrown} />
                </label>
              </span>
              { this.state.answer_quantity === "5" &&
                <span className="yellow">
                  <input className="column" type="checkbox" name="preview_answer" value="3" id={`neutral`} checked={this.state.preview_answer === "3"} onChange={this.handleChange} />
                  <label htmlFor={`neutral`}>
                    <FontAwesomeIcon icon={faMeh} />
                  </label>
                </span>
              }
              <span className={this.state.answer_quantity === "5" ? "light-green" : "yellow"}>
                <input className="column" type="checkbox" name="preview_answer" value="4" id={`happy`} checked={this.state.preview_answer === "4"} onChange={this.handleChange} />
                <label htmlFor={`happy`}>
                  <FontAwesomeIcon icon={faSmile} />
                </label>
              </span>
              <span className="very_happy">
                <input className="column" type="checkbox" name="preview_answer" value="5" id={`very_happy`} checked={this.state.preview_answer === "5"} onChange={this.handleChange} />
                <label htmlFor={`very_happy`}>
                  <FontAwesomeIcon icon={faLaughBeam} />
                </label>
              </span>
            </div>
          </div>
        </div>
      )
    }

    if (this.state.answer_type === "thumbs") {
      return (
        <div className="feedback-preview bottom-margin">
          <div className="small-bottom-margin">Answer Preview:</div>
          <div className="question radio radio-card">

            <div className="smileys">
              <span className="very_unhappy">
                <input className="column" type="checkbox" name="preview_answer" value="1" id={`very_unhappy`} checked={this.state.preview_answer === "1"} onChange={this.handleChange} />
                <label htmlFor={`very_unhappy`}>
                  <FontAwesomeIcon icon={faThumbsDown} />
                  <FontAwesomeIcon icon={faThumbsDown} />
                </label>
              </span>
              <span className="unhappy">
                <input className="column" type="checkbox" name="preview_answer" value="2" id={`unhappy`} checked={this.state.preview_answer === "2"} onChange={this.handleChange} />
                <label htmlFor={`unhappy`}>
                  <FontAwesomeIcon icon={faThumbsDown} />
                </label>
              </span>
              { this.state.answer_quantity === "5" &&
                <span className="yellow">
                  <input className="column" type="checkbox" name="preview_answer" value="3" id={`neutral`} checked={this.state.preview_answer === "3"} onChange={this.handleChange} />
                  <label htmlFor={`neutral`}>
                    <FontAwesomeIcon icon={faThumbsUp} className="rotate-90" />
                  </label>
                </span>
              }
              <span className={this.state.answer_quantity === "5" ? "light-green" : "yellow"}>
                <input className="column" type="checkbox" name="preview_answer" value="4" id={`happy`} checked={this.state.preview_answer === "4"} onChange={this.handleChange} />
                <label htmlFor={`happy`}>
                  <FontAwesomeIcon icon={faThumbsUp} />
                </label>
              </span>
              <span className="very_happy">
                <input className="column" type="checkbox" name="preview_answer" value="5" id={`very_happy`} checked={this.state.preview_answer === "5"} onChange={this.handleChange} />
                <label htmlFor={`very_happy`}>
                  <FontAwesomeIcon icon={faThumbsUp} />
                  <FontAwesomeIcon icon={faThumbsUp} />
                </label>
              </span>
            </div>
          </div>
        </div>
      )
    }

    if (this.state.answer_type === "net_promoter") {
      return (
        <div className="feedback-preview bottom-margin">
          <div className="small-bottom-margin">Answer Preview:</div>
          <div className="question radio">

            <div className="net-promoter">
              {["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map(value => {
                const inputId = `net_promoter_${value}`;
                
                return (
                  <React.Fragment key={inputId}>
                    <input className="column" type="checkbox" name="preview_answer" value={value} id={inputId} checked={this.state.preview_answer === value} onChange={this.handleChange} />
                    <label htmlFor={inputId}>{value}</label>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      )
    }

    if (this.state.answer_type === "multi_select") {
      const options = this.state.options.split("\n").map(option => option.trim()).filter(option => option)

      return (
        <div className="feedback-preview bottom-margin">
          <div className="small-bottom-margin">Answer Preview:</div>
          <div className="question">
            <div className="options" style={{gridTemplateColumns: this.organiseColumns(options)}}>
              {options.map((option, index) =>
                <div className="option" key={index}>
                  <input className="column" type="checkbox" name="preview_options" value={index} id={`option${index}`} checked={this.state.preview_options.includes(index)} onChange={this.handleMultiCheckbox} />
                  <label htmlFor={`option${index}`}>{option}</label>
                </div>
              )}
            </div>
          </div>
        </div>
      )
    }
  }

  organiseColumns(options) {
    if (options.length < 6) {
      return options.map(option => "1fr").join(" ")
    }

    for (let gridWidth = 5; gridWidth > 2; gridWidth--) {
      if (options.length % gridWidth === 0) {
        return new Array(gridWidth).fill("1fr").join(" ")
      }
    }

    return "1fr 1fr 1fr 1fr 1fr"
  }

  renderDependsOnConditionFields(depends_on_question) {
    const { depends_on_question_id, depends_on_condition, depends_on_score, errors } = this.state;
    const { disabled } = this.props;

    if (depends_on_question_id === "") {
      return
    }

    if (["text", "multi_select"].includes(depends_on_question.answer_type)) {
      return (
        <div className="row">
          <HelpText page={'feedbackQuestion'} section={'depends_on_condition'} />

          <label className="column">Depends on condition:</label>{ renderErrors(errors, 'depends_on_condition') }
          <div>
            <div className="question-type">
              <input className="column" type="radio" name="depends_on_condition" id="null" value="" checked={true} onChange={this.handleChange} disabled={disabled} />
              <label htmlFor="null">Any Answer</label>
            </div>
          </div>
        </div>
      )
    }

    let minusTwo, minusOne, zero, plusOne, plusTwo;

    switch (depends_on_question.answer_type) {
      case "boolean":
        minusTwo = "No"
        plusTwo = "Yes"
        zero = depends_on_question.answer_quantity === 3 ? "N/A" : undefined
        break;
      case "stars":
        minusTwo = "One star"
        minusOne = "Two stars"
        zero = depends_on_question.answer_quantity === 5 ? "Three stars" : undefined
        plusOne = depends_on_question.answer_quantity === 5 ? "Four stars" : "Three stars"
        plusTwo = depends_on_question.answer_quantity === 5 ? "Five stars" : "Four stars"
        break;
      case "smileys":
        minusTwo = "Very unhappy"
        minusOne = "Unhappy"
        zero = depends_on_question.answer_quantity === 5 ? "Neutral" : undefined
        plusOne = "Happy"
        plusTwo = "Very happy"
        break;
      case "thumbs":
        minusTwo = "Two thumbs down"
        minusOne = "One thumb down"
        zero = depends_on_question.answer_quantity === 5 ? "No thumbs up" : undefined
        plusOne = "One thumb up"
        plusTwo = "Two thumbs up"
        break;
      case "net_promoter":
        minusTwo = "Negative"
        zero = "Neutral"
        plusTwo = "Positive"
        break;
      default:
    }

    const gridTemplateColumns = [minusTwo, minusOne, zero, plusOne, plusTwo].filter(value => value !== undefined).map(value => "1fr").join(" ")

    return(
      <>
        <div className="row">
          <HelpText page={'feedbackQuestion'} section={'depends_on_condition'} />

          <label className="column">Depends on condition:</label>{ renderErrors(errors, 'depends_on_condition') }
          <div style={{display: "grid", gridTemplateColumns: depends_on_question.answer_quantity === 2 ? "1fr 1fr" : "1fr 1fr 1fr 1fr" }}>
            <div className="question-type">
              <input className="column" type="radio" name="depends_on_condition" id="null" value="" checked={depends_on_condition === ""} onChange={this.handleChange} disabled={disabled} />
              <label htmlFor="null">Any Answer</label>
            </div>

            <div className="question-type">
              <input className="column" type="radio" name="depends_on_condition" id="exactly" value="exactly" checked={depends_on_condition === "exactly"} onChange={this.handleChange} disabled={disabled} />
              <label htmlFor="exactly">Only</label>
            </div>

            {depends_on_question.answer_quantity !== 2 &&
              <>
                <div className="question-type">
                  <input className="column" type="radio" name="depends_on_condition" id="or_worse" value="or_worse" checked={depends_on_condition === "or_worse"} onChange={this.handleChange} disabled={disabled} />
                  <label htmlFor="or_worse">Equal Or Worse</label>
                </div>

                <div className="question-type">
                  <input className="column" type="radio" name="depends_on_condition" id="or_better" value="or_better" checked={depends_on_condition === "or_better"} onChange={this.handleChange} disabled={disabled} />
                  <label htmlFor="or_better">Equal Or Better</label>
                </div>
              </>
            }
          </div>
        </div>
        {depends_on_condition !== "" &&
          <div className="row">
            <HelpText page={'feedbackQuestion'} section={'depends_on_score'} />

            <label className="column">Depends on score:</label>{ renderErrors(errors, 'depends_on_score') }
            <div style={{display: "grid", gridTemplateColumns}}>
              <div className="question-type">
                <input className="column" type="radio" name="depends_on_score" id="-2" value="-2" checked={depends_on_score === "-2"} onChange={this.handleChange} disabled={disabled} />
                <label htmlFor="-2">{minusTwo}</label>
              </div>

              {minusOne &&
              <div className="question-type">
                <input className="column" type="radio" name="depends_on_score" id="-1" value="-1" checked={depends_on_score === "-1"} onChange={this.handleChange} disabled={disabled} />
                <label htmlFor="-1">{minusOne}</label>
              </div>
              }

              {zero &&
                <div className="question-type">
                  <input className="column" type="radio" name="depends_on_score" id="0" value="0" checked={depends_on_score === "0"} onChange={this.handleChange} disabled={disabled} />
                  <label htmlFor="0">{zero}</label>
                </div>
              }

              {plusOne &&
                <div className="question-type">
                  <input className="column" type="radio" name="depends_on_score" id="1" value="1" checked={depends_on_score === "1"} onChange={this.handleChange} disabled={disabled} />
                  <label htmlFor="1">{plusOne}</label>
                </div>
              }

              <div className="question-type">
                <input className="column" type="radio" name="depends_on_score" id="2" value="2" checked={depends_on_score === "2"} onChange={this.handleChange} disabled={disabled} />
                <label htmlFor="2">{plusTwo}</label>
              </div>
            </div>
          </div>
        }
      </>
    )

  }

  renderSaveButton() {
    if (adminUser()) {
      if (this.state.emailsValid) {
        if (this.props.disabled) {
          return <input type="submit" value="Save alerts" onClick={this.handleSubmitAlerts} />
        }

        return <input type="submit" value="Save" onClick={this.handleSubmit} />
      }
      else {
        return (
          <>
            <input type="submit" value="Cannot save invalid emails" disabled="disabled" />
            <br/>
            <input type="submit" value="Remove invalid emails" onClick={this.removeInvalidEmails} />
          </>
        )
      }
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  feedback_questions() {
    let { id, feedbackQuestions, orderLookup } = this.props;

    if (id) {
      const self = feedbackQuestions.find(feedback_question => feedback_question.id === parseInt(id))
      if (self) {
        const selfOrder = orderLookup[self.id]
        feedbackQuestions = feedbackQuestions.filter(feedback_question => orderLookup[feedback_question.id].substr(0, selfOrder.length) !== selfOrder)
      }
    }

    return feedbackQuestions.sort((a, b) => orderLookup[a.id] > orderLookup[b.id] ? 1 : -1)
  }

  render() {
    const { name, display, answer_type, answer_quantity, hidden, analysis_overview, depends_on_question_id, removeInvalidEmailsCount, submitAlertsCount, id, redirectNewPanel, loaded, unauthorized, errors, alertErrors, error } = this.state;
    const { disabled, orderLookup } = this.props;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (redirectNewPanel === true) {
      return <Redirect to={`/configuration/feedback/${this.props.feedback_type_id}/question/${id}`}/>
    }

    const title = this.props.mode === "create" ? "New" : "Edit"
    const formatName = name ? ` ${name} |` : ""

    const feedback_questions = this.feedback_questions();
    const depends_on_question = this.props.feedbackQuestions.find(feedback_question => feedback_question.id === parseInt(depends_on_question_id))
    if (loaded) {
      return (
        <div>
          <SetTitle title={`${title} Feedback Question |${formatName} Feedback`} />

          <form className="settings big-settings segment-settings">
            <div className="segment">
              <div className="row">
                <HelpText page={'feedbackQuestion'} section={'name'} />

                <label className="column">Feedback Name:</label>{ renderErrors(errors, 'name') }
                <input className="column" type="text" name="name" value={name} onChange={this.handleChange} disabled={disabled} />
              </div>

              <div className="row">
                <HelpText page={'feedbackQuestion'} section={'question'} />

                <label className="column">Feedback Question:</label>{ renderErrors(errors, 'display') }
                <input className="column" type="text" name="display" value={display} onChange={this.handleChange} disabled={disabled} />
              </div>

              <div className="row">
                <HelpText page={'feedbackQuestion'} section={'type'} />

                <label className="column">Question Type:</label>{ renderErrors(errors, 'answer_type') }

                <div className="question-types">
                  <div className="question-type">
                    <input className="column" type="radio" name="answer_type" id="boolean" value="boolean" checked={answer_type === "boolean"} onChange={this.handleChange} disabled={disabled} />
                    <label htmlFor="boolean">Yes/No</label>
                  </div>

                  <div className="question-type">
                    <input className="column" type="radio" name="answer_type" id="stars" value="stars" checked={answer_type === "stars"} onChange={this.handleChange} disabled={disabled} />
                    <label htmlFor="stars">Stars</label>
                  </div>

                  <div className="question-type">
                    <input className="column" type="radio" name="answer_type" id="smileys" value="smileys" checked={answer_type === "smileys"} onChange={this.handleChange} disabled={disabled} />
                    <label htmlFor="smileys">Smileys</label>
                  </div>

                  <div className="question-type">
                    <input className="column" type="radio" name="answer_type" id="thumbs" value="thumbs" checked={answer_type === "thumbs"} onChange={this.handleChange} disabled={disabled} />
                    <label htmlFor="thumbs">Thumbs</label>
                  </div>

                  <div className="question-type">
                    <input className="column" type="radio" name="answer_type" id="text" value="text" checked={answer_type === "text"} onChange={this.handleChange} disabled={disabled} />
                    <label htmlFor="text">Text</label>
                  </div>

                  <div className="question-type">
                    <input className="column" type="radio" name="answer_type" id="multi_select" value="multi_select" checked={answer_type === "multi_select"} onChange={this.handleChange} disabled={disabled} />
                    <label htmlFor="text">Multi-Select</label>
                  </div>

                  <div className="question-type">
                    <input className="column" type="radio" name="answer_type" id="net_promoter" value="net_promoter" checked={answer_type === "net_promoter"} onChange={this.handleChange} disabled={disabled} />
                    <label htmlFor="net_promoter">Net Promoter</label>
                  </div>
                </div>
              </div>

              { ["boolean", "stars", "smileys", "thumbs"].includes(answer_type) &&
                <div className="row">
                  <HelpText page={'feedbackQuestion'} section={'answer_quantity'} />

                  <label className="column">Answer Quantity:</label>{ renderErrors(errors, 'answer_quantity') }

                  <div className="answer-quantity">
                    { answer_type === "boolean" ?
                      <>
                        <div className="question-type">
                          <input className="column" type="radio" name="answer_quantity" id="two" value="2" checked={answer_quantity === "2"} onChange={this.handleChange} disabled={disabled} />
                          <label htmlFor="two">Two(No, Yes)</label>
                        </div>

                        <div className="question-type">
                          <input className="column" type="radio" name="answer_quantity" id="three" value="3" checked={answer_quantity === "3"} onChange={this.handleChange} disabled={disabled} />
                          <label htmlFor="three">Three(No, N/A, Yes)</label>
                        </div>
                      </>
                      :
                      <>
                        <div className="question-type">
                          <input className="column" type="radio" name="answer_quantity" id="four" value="4" checked={answer_quantity === "4"} onChange={this.handleChange} disabled={disabled} />
                          <label htmlFor="four">Four</label>
                        </div>

                        <div className="question-type">
                          <input className="column" type="radio" name="answer_quantity" id="five" value="5" checked={answer_quantity === "5"} onChange={this.handleChange} disabled={disabled} />
                          <label htmlFor="five">Five</label>
                        </div>
                      </>
                    }
                  </div>
                </div>
              }

              { answer_type === "multi_select" &&
                <div className="row">
                  <HelpText page={'feedbackQuestion'} section={'options'} />

                  <label className="column">Answer Options:</label>{ renderErrors(errors, 'options') }
                  <textarea aria-required="true" name="options" value={this.state.options} onChange={this.handleChange} />
                </div>
              }

              {this.renderQuestionPreview()}

              <div className="row">
                {depends_on_question?.hidden && <NoticeBox type={"info"} text={"This question will always be hidden as it depends on a hidden question"} />}
                <HelpText page={'feedbackQuestion'} section={'hidden'} />

                <input className="column" type="checkbox" name="hidden" id="hidden_question_checkbox" checked={hidden} onChange={this.handleCheckbox} disabled={disabled} />
                <label className="column checkbox-label" htmlFor="hidden_question_checkbox">Hidden?</label>{ renderErrors(errors, 'hidden') }

                <HelpText page={'feedbackQuestion'} section={'analysis_overview'} />

                <input className="column" type="checkbox" name="analysis_overview" id="analysis_overview_checkbox" checked={analysis_overview} onChange={this.handleCheckbox} disabled={disabled} />
                <label className="column checkbox-label" htmlFor="analysis_overview_checkbox">Include in Analysis Graphs?</label>{ renderErrors(errors, 'analysis_overview') }
              </div>
            </div>

            {feedback_questions.length > 0 &&
              <div className="segment">
                <div className="row">
                  <HelpText page={'feedbackQuestion'} section={'depends_on_question'} />

                  <label className="column">Depends on question:</label>{ renderErrors(errors, 'depends_on_question') }
                  <select name="depends_on_question_id" onChange={this.handleChange} value={depends_on_question_id} disabled={disabled}>
                    <option value="">Select</option>
                    {feedback_questions.map((feedback_question) => (
                      <option value={feedback_question.id} key={feedback_question.id}>{`${orderLookup[feedback_question.id]}: ${feedback_question.name}`}</option>
                    ))}
                  </select>
                </div>

                {this.renderDependsOnConditionFields(depends_on_question)}
              </div>
            }
          </form>

          <AlertProcessing id={this.props.id || id} current_answer_type={answer_type} current_answer_quantity={answer_quantity} closePanel={this.props.mode === "create" ? this.setNewPanelRedirect : this.props.closePanel} setEmailsValid={this.setEmailsValid} setErrors={this.setAlertErrors} removeInvalidEmailsCount={removeInvalidEmailsCount} submitAlertsCount={submitAlertsCount} origin={this.props.mode || "update"} />

          <form className="settings big-settings">
            { this.renderSaveButton() }
            { renderErrorWarning(errors) }
            { renderErrorWarning(alertErrors) }
          </form>

          { this.props.mode !== "create" && <Audits klass="FeedbackQuestion" id={this.props.id} /> }
        </div>
      );
    }
  }

  componentDidMount() {
    if (this.props.mode === "create") {
      this.setState({ loaded: true })
      return
    }

    let id = this.props.id;

    request('GET', `/v1/a/feedback_questions/${id}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({
          name: data.name,
          display: data.display,
          answer_type: data.answer_type,
          answer_quantity: data.answer_quantity?.toString() || this.state.answer_quantity,
          options: data.options || FeedbackQuestionForm.DEFAULT_OPTIONS,
          hidden: data.hidden,
          analysis_overview: data.analysis_overview,
          depends_on_question_id: data.depends_on_question_id || "",
          initial_depends_on_question_id: data.depends_on_question_id || "",
          depends_on_condition: data.depends_on_condition || "",
          depends_on_score: data.depends_on_score?.toString() || this.state.depends_on_score,
          loaded: true
        })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, loaded: true })
      })
  }
}

export default FeedbackQuestionForm;
